import {
  Box,
  Flex,
  Modal,
  Text,
  useMantineTheme,
  Button,
  Transition,
  Overlay,
  Loader,
  HoverCard,
  ScrollArea
} from "@mantine/core";
import { BagelIcon20, BagelIcon40, BagelIcon60, BagelIcon80, BagelIcon100 } from "../../../icons/x-symbol-svgrepo-com";
import ValidationModalSideBar from "../right-bar/evidence-card/ValidationModalSidebar";
import { IconCircleCheck, IconCheck, IconX } from "@tabler/icons";
import { showNotification } from "@mantine/notifications";
import { updateValidation } from "../../../Api";
import { useAuth0 } from "@auth0/auth0-react";
import { DARK_GREY_TEXT, MAIN_DARK_PRIMARY } from "../../../constants/colors";
import { useContext } from "react";
import IdeaContext from "../IdeaContext";

interface ReassignModalProps {
  ideaId: string,
  maturity: number,
  validateModalOpened: boolean;
  setValidateModalOpened: (opened: boolean) => void;
  reviewMode: any;
  navToPerspective: any;
  setActiveSearch: any;
  validationEvidence: any;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  setideaValidationData: any;
  setMaturity: any;
  handlebannerText: any;
  setValidationCount: any;
  validationCount: number | null;
  setIsValidationDone: any;
  isValidationDone: boolean | null;
}
function ValidateModal({
  ideaId,
  maturity,
  validateModalOpened,
  setValidateModalOpened,
  reviewMode,
  navToPerspective,
  setActiveSearch,
  validationEvidence,
  loading,
  setLoading,
  setideaValidationData,
  setMaturity,
  handlebannerText,
  setValidationCount,
  validationCount,
  setIsValidationDone,
  isValidationDone,
}: ReassignModalProps) {
  const theme = useMantineTheme();
  let title = "Help Bagel focus on the most relevant evidences "
  let text = "If the Evidence is relevant to this Idea – Click “Assign to this idea”, otherwise click “Not relevant”"
  let CardIcon = BagelIcon20
  if(validationCount == 4){
    title = "You’ve done an amazing job refining the evidences!"
    text = "Only a few more to complete the Idea validation"
    CardIcon = BagelIcon80
  } else if(validationCount == 3){
    title = "You’ve done an amazing job refining the evidences!"
    text = "Only a few more to complete the Idea validation "
    CardIcon = BagelIcon60
  } else if(validationCount == 2){
    title = "Every choice you make helps us create a stronger case for your idea!"
    text = "Keep working!"
    CardIcon = BagelIcon40
  }
  const auth0 = useAuth0();
  const { idea } = useContext(IdeaContext);
  
  const finishProcess = () => {
    setValidateModalOpened(false)
    updateValidation(
      auth0, 
      {id: ideaId, verifyState:'completed', validationCount: 5}
    )
      .then(() => {
        showNotification({
          title: "Idea marked verified successfuly",
          color: "teal",
          message: "",
          icon: <IconCheck size="1.1rem" />,
          autoClose: 1200
        });
      })
      .catch((e) => {
        console.log(e);
        showNotification({
          title: "Error in Idea verification",
          color: "red",
          message: "please try again...",
          icon: <IconX size="1.1rem" />,
          autoClose: 1200
        });
      });
  }

  const onClose = () => {
    setValidateModalOpened(false)
  }

  return (
    <Modal
      opened={validateModalOpened}
      onClose={() => onClose()}
      withCloseButton={false}
      overlaycolor={
        theme.colorScheme === "dark"
          ? theme.colors.dark[9]
          : theme.colors.gray[2]
      }
      overlayopacity={0.55}
      overlayblur={3}
      size={"992px"}
      padding={"0px"}
      sx={{
        ".mantine-Modal-content": {
          borderRadius: 8,
          overflow: "hidden"
        },
        ".mantine-1ajh50z": {
          width: '100%'
        },
        ".mantine-b6zkvl > div": {
          display: 'block !important'
        },
        ".mantine-ninawr": {
          height: '57px'
        },
        ".mantine-51v439": {
          paddingRight: '10px'
        }
      }}
      scrollAreaComponent={ScrollArea.Autosize}
    >
      {loading && (
        <Overlay
          color="rgb(255 255 255 / 30%)" 
          zIndex={1000} 
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader size="xl" />
        </Overlay>
      )}
      {!isValidationDone && (
        <Flex w="100%" h="660px">
          <Flex w={"48%"} bg={"#5C5CEB"} pt="25px" p={"46px"} direction="column">
            <HoverCard>
              <HoverCard.Target>
                <Box
                  bg="#F1F1F1"
                  style={{
                    width: '115%',
                    borderRadius: '8px',
                    marginLeft: '-28px',
                    marginRight: '-28px',
                    marginTop: '-7px'
                  }}           
                  p="12px"
                  mb="20px"
                  mx="auto"
                  w="100%"
                >
                  <Text fz={10} color={DARK_GREY_TEXT} mb="10px">
                    IDEA DETAILS
                  </Text>
                  <Text
                    fz={18}
                    fw={600}
                    color={MAIN_DARK_PRIMARY}
                    mb="5px"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {idea.title}
                  </Text>
                  <Text
                    fz={14}
                    fw={600}
                    color='#585c68'
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {idea.description}
                  </Text>
                </Box>
              </HoverCard.Target>
              <HoverCard.Dropdown sx={{boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}}>
                <Box
                  w={345}
                >
                  <Text
                    w={345}
                    maw={345}
                    mb={2}
                    fz={14}
                    fw={600}
                    color={MAIN_DARK_PRIMARY}
                    sx={{
                      maxHeight: 100,
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: 'vertical',

                    }}
                  >
                    {idea.title}
                  </Text>
                  <Text
                    size="sm"
                    sx={{
                      whiteSpace: 'pre-wrap',
                      maxHeight: 100,
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: 'vertical',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {idea.description}
                  </Text>
                </Box>
              </HoverCard.Dropdown>
            </HoverCard>
            <Transition
              mounted={!loading && !isValidationDone}
              transition="fade"
              duration={500}
              timingFunction="ease-in-out"
            >
              {(styles) => (
                <Flex
                  style={styles}
                  justify={"center"}
                  align={"center"}
                  direction={"column"}
                >
                  <Text
                    fz={20}
                    color="#ffffff"
                    fw={600}
                    lh={"29px"}
                    mb={"15px"}
                  >
                    {title}
                  </Text>
                  <Text
                    fz={18}
                    color="#ffffff"
                    fw={400}
                    mb={"50px"}
                    lh={"27px"}
                  >
                    {text}
                  </Text>
                  <CardIcon/>
                </Flex>
              )}
            </Transition>
          </Flex>
          <Box w={"52%"} bg={"white"}>
            <Transition
              mounted={!loading && !isValidationDone}
              transition="fade"
              duration={500}
              timingFunction="ease-in-out"
            >
              {(styles) => (
                <Box style={styles}>
                  <ValidationModalSideBar
                    reviewMode={reviewMode}
                    navToPerspective={navToPerspective}
                    setActiveSearch={setActiveSearch}
                    ideaPage
                    validateModalOpened={validateModalOpened}
                    setValidateModalOpened={setValidateModalOpened}
                    validationEvidence={validationEvidence}
                    loading={loading}
                    setLoading={setLoading}
                    setideaValidationData={setideaValidationData}
                    setMaturity={setMaturity}
                    handlebannerText={handlebannerText}
                    validationCount={validationCount}
                    setValidationCount={setValidationCount}
                    setIsValidationDone={setIsValidationDone}
                  />
                </Box>
              )}
            </Transition>
          </Box>
        </Flex>
      )}
      {isValidationDone && (
        <Flex w="100%" h="660px">
          <Flex w={"48%"} bg={"#5C5CEB"} justify={"center"} align={"center"}>
            <Transition
              mounted={!loading && isValidationDone}
              transition="fade"
              duration={500}
              timingFunction="ease-in-out"
            >
              {(styles) => <BagelIcon100 style={styles} />}
            </Transition>
          </Flex>
          <Box w={"52%"} bg={"white"}>
            <Transition
              mounted={!loading && isValidationDone}
              transition="fade"
              duration={500}
              timingFunction="ease-in-out"
            >
              {(styles) => (
                <Flex
                  justify={"center"}
                  align={"center"}
                  h={"660px"}
                  style={styles}
                >
                  <Box w={"338px"}>
                    <IconCircleCheck fill="#0BAC4D" color="#ffffff" size={45} />
                    <Text fz={20} fw={600} mt={"5px"} ml={"8px"}>
                      You are done!
                    </Text>
                    <Text fz={18} color="#585C68" my={"5px"} ml={"8px"}>
                      This Idea is now set to receive the most
                      relevant evidences
                    </Text>
                    <Button
                      w={"70px"}
                      fz={"12px"}
                      fw={500}
                      style={{
                        color: "#ffffff",
                        backgroundColor: "#5C5CEB",
                        height: "32px",
                      }}
                      ml={"8px"}
                      p={"0px"}
                      onClick={() => finishProcess()}
                    >
                      <IconCircleCheck
                        fill="#ffffff"
                        color="#5C5CEB"
                        size={16}
                      />
                      <Text ml={"5px"}>Finish</Text>
                    </Button>
                  </Box>
                </Flex>
              )}
            </Transition>
          </Box>
        </Flex> 
      )}
    </Modal>
  );
}

export default ValidateModal;
